// src/utils/clearDemoStorage.js
//
// One-stop demo-state cleanup for the browser. The backend can wipe and
// reseed its own data via POST /api/demo/reset, but localStorage keys
// (onboarding completion flags, KIRA prefill, etc.) are per-browser and
// unreachable from the server. This util gives both:
//
//   1. clearDemoStorage()                — programmatic call returning
//                                          the list of keys that were cleared
//   2. window.clearDemoStorage = ...     — global handle for the browser
//                                          console (installed in src/index.js
//                                          via installDemoStorageHelper)
//
// Safe-to-keep keys are explicitly excluded: anything starting with
// "kwery_token" or "kwery_refresh" is left alone so we don't accidentally
// boot the operator out mid-demo. Auth tokens live under "token" /
// "refresh_token" anyway (see AuthContext._applySession).

const DEMO_PREFIXES = [
  "kwery_onboarding_",   // _done_<uid>, _step_<uid>
  "kwery_kira_prefill",
];

const KEEP_PREFIXES = [
  "kwery_token",
  "kwery_refresh",
];

function _matchesDemoKey(k) {
  if (!k.startsWith("kwery_")) return false;
  if (KEEP_PREFIXES.some((p) => k.startsWith(p))) return false;
  return true;
}

export function clearDemoStorage() {
  let cleared = [];
  try {
    cleared = Object.keys(localStorage).filter(_matchesDemoKey);
    cleared.forEach((k) => {
      try { localStorage.removeItem(k); } catch {}
    });
    // eslint-disable-next-line no-console
    console.log(
      "Demo storage cleared:", cleared,
      "\nRefresh and log in to see onboarding again."
    );
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error("[clearDemoStorage] failed:", e);
  }
  return cleared;
}

// Optional sharp version — used by any future "Reset demo" button that
// also wants to wipe ONLY the onboarding-related keys (not other kwery_*).
export function clearOnboardingStorage() {
  const cleared = Object.keys(localStorage).filter((k) =>
    DEMO_PREFIXES.some((p) => k === p || k.startsWith(p))
  );
  cleared.forEach((k) => {
    try { localStorage.removeItem(k); } catch {}
  });
  return cleared;
}

// Wire the function onto window for browser-console use.
export function installDemoStorageHelper() {
  if (typeof window !== "undefined") {
    window.clearDemoStorage = clearDemoStorage;
  }
}
